var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icono / Outlined / Valoracion") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.002,1 C11.648,1 11.293,1.272 11.023,1.816 L8.115,7.711 L1.588,8.661 C0.389,8.836 0.113,9.672 0.984,10.521 L5.7,15.119 L4.588,21.622 C4.44,22.49 4.773,23 5.377,23 C5.606,23 5.873,22.927 6.168,22.772 L12,19.707 L17.832,22.772 C18.127,22.927 18.395,23 18.624,23 C19.229,23 19.563,22.49 19.413,21.622 L18.3,15.119 L23.016,10.521 C23.886,9.672 23.613,8.836 22.412,8.661 L15.887,7.711 L12.979,1.816 C12.71,1.272 12.356,1 12.002,1 M12.001,4.355 L14.093,8.596 L14.558,9.539 L15.599,9.69 L20.3,10.375 L16.903,13.688 L16.151,14.421 L16.328,15.457 L17.131,20.144 L12.931,17.936 L12,17.447 L11.069,17.936 L6.87,20.144 L7.672,15.457 L7.849,14.421 L7.097,13.688 L3.7,10.375 L8.403,9.69 L9.443,9.539 L9.908,8.596 L12.001,4.355",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Outlined-/-Valoracion",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Primary-/-500",
    mask: "url(#mask-2)",
    fill: "#b0b0b0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1a0f5411b6e22ec7b1d5468867b23888.svg";
export { ForwardRef as ReactComponent };